<template>
  <IQOSModal>
    <template #title>
      {{ $t("promocode_add_modal.title") }}
    </template>

    <BaseTabSwitcher
      class="w-100"
      :tabs="[
        {
          text: $t('promocode_add_modal.tab_single'),
          value: true,
        },
        {
          text: $t('promocode_add_modal.tab_multi'),
          value: false,
        },
      ]"
      v-model="form.is_custom"
    />

    <BaseInput
      type="number"
      class="w-100 mt-16"
      fullWidth
      v-model.number="form.count"
      :placeholder="$t('promocode_add_modal.count_ph')"
      v-if="!form.is_custom"
    />

    <!-- <div class="gap-column-xs mt-16">
      <BaseCheckbox v-model="form.one_per_client"/>

    <span class="qrw-heading-xs" :class="form.one_per_client ? 'v1-grey-2-color' : 'v1-grey-7-color'">
      {{ $t('promocode_add_modal.one_per_client') }}
    </span>
    </div> -->

    

    <BaseInput
      v-model="form.custom_promocode"
      fullWidth
      :readonly="false"
      class="mt-16"
      :placeholder="$t('promocode_add_modal.custom_ph')"
      v-if="form.is_custom"
    />

    <BaseInput
      type="number"
      class="w-100 mt-16"
      fullWidth
      v-model.number="form.max_uses_per_client"
      :placeholder="$t('promocode_add_modal.max_limit')"
      v-if="form.is_custom"
    />

    <BaseSelect
      v-model="form.promo_type"
      fullWidth
      class="mt-16"
      :placeholder="$t('promocode_add_modal.type_ph')"
    >
      <option v-for="pt in available_types" :key="pt" :value="pt">
        {{ $t("promocode_types." + pt) }}
      </option>
    </BaseSelect>

    <template v-if="isDiscountPromocode">
      <BaseUnitInput
        type="number"
        unitPlaceholder="%"
        fullWidth
        class="mt-8"
        v-model.number="form.discount"
        :readonly="false"
        :placeholder="$t('promocode_add_modal.discount_ph')"
      />

      <BaseSelect fullWidth class="mt-8" v-model="form.menu_id">
        <option :value="null">
          {{ $t("add_discount.all_menus") }}
        </option>
        <option v-for="menu in menus" :key="menu._id" :value="menu._id">
          {{ menu.title }}
        </option>
      </BaseSelect>
      <BaseSelect class="mt-8" v-if="form.menu_id" v-model="form.category_id">
        <option :value="null">
          {{ $t("add_discount.all_categories") }}
        </option>
        <option
          v-for="category in selectedMenu.categories"
          :key="category._id"
          :value="category._id"
        >
          {{ category.name }}
        </option>
      </BaseSelect>
      <BaseSelect
        class="mt-8"
        fullWidth
        v-model="form.dish_id"
        v-if="form.category_id"
      >
        <option :value="null">
          {{ $t("add_discount.all_products") }}
        </option>
        <template v-if="form.category_id">
          <option
            v-for="product in selectedCategoryProducts"
            :key="product._id"
            :value="product._id"
          >
            {{ product.name }}
          </option>
        </template>
      </BaseSelect>
    </template>

    <template #actions>
      <BaseButton
        variant="secondary"
        color="v1-grey-3"
        size="md"
        class="w-100"
        @click="$emit('close')"
      >
        {{ $t("add_campaign.cancel") }}</BaseButton
      ><BaseButton
        variant="secondary"
        color="green-5"
        class="w-100"
        size="md"
        @click="createPromocode"
        :disabled="!canCreatePromocode"
        >{{ $t("add_campaign.confirm") }}</BaseButton
      >
    </template>
  </IQOSModal>
</template>
<script>
import moment from "moment";

import PromocodesAPI from "@/api/promocodes";

export default {
  components: {},
  data() {
    return {
      form: {
        is_custom: true,
        promo_type: null,
        discount: null,
        menu_id: null,
        dish_id: null,
        category_id: null,
        max_uses_per_client: null,

        menu_name: null,
        dish_name: null,
        category_name: null,
        custom_promocode: null,
        count: null,
        cafe_id: null,
      },

      available_types: ["check_discount", "free_delivery"],
    };
  },
  methods: {
    createPromocode() {
      this.form.cafe_id = this.$store.state.cafe._id;
      if (this.form.custom_promocode)
        this.form.custom_promocode = this.form.custom_promocode.toUpperCase();

      if (this.form.menu_id)
        this.form.menu_name = this.selectedMenu.tag || this.selectedMenu.title;
      if (this.form.category_id)
        this.form.category_name = this.selectedCategory.name;
      if (this.form.dish_id)
        this.form.dish_name = (
          this.selectedCategoryProducts.find(
            (p) => p._id == this.form.dish_id
          ) || {}
        ).name;

      if (!this.form.max_uses_per_client || this.form.max_uses_per_client < 0) {
        this.form.max_uses_per_client = 0;
      }

      PromocodesAPI.create(this.form)
        .then((data) => {
          this.$emit("created");

          this.$store.dispatch("auditlog/write", {
            type: "create_promocode",
            payload: this.form,
          });
        })
        .catch((err) => {
          this.$store.dispatch("showError", "promocodes_error");
        });
    },
  },
  computed: {
    menus() {
      return this.$store.state.menu.menus;
    },
    selectedMenu() {
      if (!this.form.menu_id) return {};

      return this.menus.find((m) => m._id == this.form.menu_id);
    },
    selectedCategory() {
      if (!this.form.category_id) return null;

      return this.selectedMenu.categories.find(
        (c) => c._id == this.form.category_id
      );
    },
    selectedCategoryProducts() {
      if (!this.form.category_id) return [];

      return this.selectedMenu.products.filter(
        (p) => p.category_id == this.form.category_id
      );
    },
    isDiscountPromocode() {
      return ["dish_discount", "check_discount"].includes(this.form.promo_type);
    },
    canCreatePromocode() {
      if (!this.form.promo_type) return false;

      if (
        this.form.is_custom &&
        this.form.custom_promocode &&
        this.form.custom_promocode.length < 4
      )
        return false;

      if (this.form.promo_type == "dish_discount" && !this.form.dish_id)
        return false;

      if (!this.form.is_custom && this.form.count > 100) return false;

      if (this.isDiscountPromocode && !this.form.discount) return false;

      return true;
    },
  },
};
</script>
<style scoped>
.compagin-pop-up-wrapper {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.flex-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.line-split {
  font-size: 4vh;
  color: #ededed;
  margin: 0 3.3333333333333335vh;
}
.container-box.iqos-static.flex-row {
  justify-content: space-between;
}
.w-35 {
  width: 35%;
}
.pop-up-message {
  font-size: 2.222vh;
  line-height: 2.5555555555555554vh;
  color: #908f8d;
}
</style>

<style>
.vc-text-base {
  padding: 0.5vh 1vh;
  width: 100%;
  margin-right: 0 !important;
  text-align: center;
}
</style>